module.exports = __webpack_public_path__ + "static/media/places-lived.39121014.svg";